
import { isIos } from './util'
import isMobileApp from '../../util/is_mobile_app'

async function nativeAppleLogin () {
  const SigningWithApple = window.Capacitor.Plugins.SignInWithApple

  const data = await SigningWithApple.Authorize()
  return {
    firstName: data.response.givenName,
    lastName: data.response.familyName,
    idToken: data.response.identityToken
  }
}

async function nativeGoogleLogin () {
  const GoogleAuth = window.Capacitor.Plugins.GoogleAuth

  const user = await GoogleAuth.signIn()
  GoogleAuth.signOut()

  return {
    idToken: user.authentication.idToken
  }
}

export default async function nativeLoginFlow (ssoProvider = '') {
  if (isIos() && ssoProvider === 'apple') {
    return nativeAppleLogin()
  } else if (isMobileApp() && ssoProvider === 'google') {
    return nativeGoogleLogin()
  } else {
    return Promise.resolve(null)
  }
}
